import { KpiCategoryType, KpiDocument, KpiSpec } from "../../models/kpis";
import { KpiDataPoint } from "../../utils/kpiUtils";
import { DateTime } from "luxon";

export interface DateRange {
  startDate: string;
  endDate: string;
}

export function getDefaultDateRange(): DateRange {
  return {
    startDate: DateTime.now().minus({ months: 1 }).toISODate(),
    endDate: DateTime.now().toISODate(),
  };
}

export interface KPIBaseProps {
  siteKey: string;
}

interface UserKPIChartData {
  categoryType: KpiCategoryType;
  categories: string[];
  data: KpiDataPoint[];
  title: string;
  subTitle: string;
  formatting: "integer" | "currency" | "percent" | "double";
  groupByDate: "month" | "week" | "day";
  handleGroupByDateChange: (value: "month" | "week" | "day") => void;
  stacked: boolean;
  kpiType: string;
}

export interface UserKPIState {
  isFetchingKpiSpecs: boolean;
  isFetchingData: boolean;
  kpiSpecs: Record<string, KpiSpec>;
  firestoreData: Record<string, KpiDocument[]>;
  rawData: Record<string, KpiDataPoint[]>;
  chartData: UserKPIChartData[];
  groupByDate: "month" | "week" | "day";
  tableDataByDate: KpiDataPoint[];
  tableDataByCategory: KpiDataPoint[];
  categories: string[];
  kpiCategoryType: KpiCategoryType;
}

export const initialUserKPIState: UserKPIState = {
  isFetchingKpiSpecs: false,
  isFetchingData: false,
  kpiSpecs: {},
  firestoreData: {},
  rawData: {},
  chartData: [],
  groupByDate: "month",
  tableDataByDate: [],
  tableDataByCategory: [],
  categories: [],
  kpiCategoryType: "userID",
};
